module.exports = __webpack_public_path__ + "assets/images/global-quality-gold-elite-2015-bajatuseguro.png";